import React, { useState } from "react";
import { useCalls, StreamCall, useCallStateHooks, CallingState, useConnectedUser } from "@stream-io/video-react-sdk";
import { motion, AnimatePresence } from "framer-motion";
import CallSection from "../Components/Chat/section/call-section";

const CallNotification = ({ call }) => {
    const { useCallCallingState, useCallMembers } = useCallStateHooks()
    const connectedUser = useConnectedUser();
    const [showCall, setShowCall] = useState(false)
    const callingState = useCallCallingState()
    const members = useCallMembers();
    const membersToShow = (members || []).map(({ user }) => user).filter((user) => user.id !== connectedUser.id) || [];
    const { name } = membersToShow[0] ?? {}

    const joinCall = async (e) => {
        e.stopPropagation()
        try {
            await call.join()
        } catch (error) {
            console.log('unable to join code; ', error.messaafe)
        }
    }

    const rejectCall = async (e) => {
        e.stopPropagation()
        try {
            await call.reject()
        }
        catch (error) {
            console.log('unable to leave call ;', error.message)
        }
    }

    return (
        <div>
            <AnimatePresence>
                {callingState === CallingState.RINGING && !call.isCreatedByMe && <motion.div
                    initial={{ y: -100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -100, opacity: 0 }}
                    onClick={() => setShowCall(true)}
                    transition={{ duration: 0.3 }}
                    className="fixed top-0 left-0 right-0 bg-gray-900 text-white p-4 shadow-lg flex items-center justify-between z-[100] cursor-pointer"
                >
                    <div>
                        <p className="text-lg font-semibold">{name} is calling...</p>
                    </div>
                    <div className="flex gap-4">
                        <button onClick={joinCall} className="bg-green-500 hover:bg-green-600 p-2 rounded-md">
                            Pick
                        </button>
                        <button onClick={rejectCall} className="bg-red-500 hover:bg-red-600 p-2 rounded-md">
                            End
                        </button>
                    </div>
                </motion.div>}
            </AnimatePresence>

            {(callingState === CallingState.JOINED ||callingState === CallingState.JOINING || call.isCreatedByMe || showCall) &&
                <CallSection />
            }
        </div>
    );
};




export const CallProvider = ({ children }) => {
    const calls = useCalls()
    const call = calls[0]


    return (
        <div>
            {call &&
                <div className="fixed z-[100]" >
                    <StreamCall call={call}>
                        <CallNotification call={call} />
                    </StreamCall>
                </div>
            }

            {children}

        </div>


    )
}